export default __webpack_public_path__ + "static/media/landing.9faf6f83.jpg";